module.exports = __webpack_public_path__ + "assets/img/31803a0695af4c3c13a0464940f29dd9.png";